import Typography from "aldoo-ra/Typography"
import TextBundle from "aldoo-ra/CMS/text-bundle"

const HCContentRenderer = ({ html }) => {
  const texts = TextBundle({ id: "help-center" })

  if (!html) {
    return (
      <Typography variant="body1_dim">
        {texts?.no_content_available || "No content available"}
      </Typography>
    )
  }

  const sanitizeHtml = (dirtyHtml) => {
    let cleanHtml = dirtyHtml.replace(/class=""/g, "")
    cleanHtml = cleanHtml.replace(/file:\/\/\/.*?\.png/g, "")
    cleanHtml = cleanHtml.replace(/<br class="">/g, "<br>")
    cleanHtml = cleanHtml.replace(/<font.*?>(.*?)<\/font>/g, "$1")
    return cleanHtml
  }

  return (
    <div
      className="prose max-w-none"
      dangerouslySetInnerHTML={{ __html: sanitizeHtml(html) }}
    />
  )
}

export default HCContentRenderer
